<!--
<template>
  <div>
    <h2>Login</h2>
    <form @submit.prevent="login">
      <input v-model="username" type="text" placeholder="Username" required />
      <input v-model="password" type="password" placeholder="Password" required />
      <vue-recaptcha sitekey="6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI" @verify="onCaptchaVerified"></vue-recaptcha>
      <button type="submit">Login</button>
    </form>
    <p>
      Don't have an account? <router-link to="/register">Register here</router-link>
    </p>
  </div>
</template>
-->

<template>
  <div class="container mt-5">
    <h2 class="text-center">Login</h2>
    <form @submit.prevent="login(0)" class="d-flex flex-column align-items-center">
      <div class="form-group mb-3">
        <input v-model="username" type="text" placeholder="Username" required class="form-control" />
      </div>
      <div class="form-group mb-3">
        <input v-model="password" type="password" placeholder="Password" required class="form-control" />
      </div>
      <div class="form-group mb-3">
        <vue-recaptcha sitekey="6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI" @verify="onCaptchaVerified"></vue-recaptcha>
      </div>
      <div class="form-group mb-3">
        <button type="submit" class="btn btn-primary">Login</button>
      </div>
      <p>
        Don't have an account? <router-link to="/register" class="btn btn-link">Register here</router-link>
      </p>
    </form>
  </div>
</template>

<script>
import axios from 'axios'
import { ref, onMounted } from 'vue'
import { getCurrentInstance } from 'vue'
import { useRouter } from 'vue-router'
import VueRecaptcha from 'vue3-recaptcha2'
import { Preferences } from '@capacitor/preferences'

export default {
  components: {
    VueRecaptcha
  },
  setup() {
    const username = ref("")
    const password = ref("")
    const pre_username = ref("")
    const pre_password = ref("")
    const captchaVerified = ref(false)
    const router = useRouter()
    const currentInstance = getCurrentInstance()
    const PhiveHost = currentInstance.appContext.config.globalProperties.PhiveHost
  
    //const showDevice = (response) => {
    const onCaptchaVerified = (response) => {
      captchaVerified.value = true
    }

    const login = async (autologin) => {
      if(autologin!=1) {
        if (!captchaVerified.value) {
          alert('Please verify the captcha')
          return
        }
      }

      const payload = {
        user: autologin!=1 ? username.value+'@phive' : pre_username.value+'@phive',
        passwd: autologin!=1 ? password.value : pre_password.value
      }

      try {
        const response = await axios.post(PhiveHost+'/cgi-bin/userauth.cgi', payload, { headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
        if (response.data.code === 0) {
          localStorage.setItem('token', response.data.token)
          if(autologin!=1) {
            await Preferences.set({
              key: 'username',
              value: username.value,
            });
            await Preferences.set({
              key: 'password',
              value: password.value,
            });
          }

          router.push('/top')
        } else {
          alert(response.data.msg)
          await Preferences.remove({ key: 'username' });
          await Preferences.remove({ key: 'password' });
        }
      } catch (error) {
        console.error(error)
        alert('Login failed')
      }
    }

    const checkuser = async () => {
      let ret = await Preferences.get({ key: 'username' });
      pre_username.value = ret.value;
      ret = await Preferences.get({ key: 'password' });
      pre_password.value = ret.value;

      if(pre_username.value!=null && pre_username.value.length>0 && pre_password.value!=null && pre_password.value.length>0) {
        login(1)
      }

    }

    onMounted(() => {
      checkuser()
    })

    return {
      username,
      password,
      pre_username,
      pre_password,
      captchaVerified,
      login,
      onCaptchaVerified
    }
  }
}
</script>
